import { useQuery } from "@apollo/client/react";
import { CustomFieldsListDataDocument } from "#app/lib/data";

const CF_LIST_VARIABLES = { limit: 200 } as const;

export function useCustomFieldsList(skip: boolean) {
  return useQuery(CustomFieldsListDataDocument, {
    variables: CF_LIST_VARIABLES,
    skip,
  });
}
